<template>
  <div id="page">
    <NavBarHome />

    <main class="pattern">
      <!--  SHOW: ALWAYS - SEARCH  -->
      <section class="hero_single version_5">
        <div class="wrapper">
          <div
            class="container"
            style="margin-top: 3rem;"
          >
            <div class="row justify-content-center pt-lg-5">
              <div class="col-xl-5 col-lg-6 search-right-margin">
                <h3 class="home_title">
                  {{ $t('lang.city_home.search_title', {city: cityName}) }}
                </h3>
                <h1 class="home_subtitle">
                  {{ $t('lang.search.text') }}
                </h1>

                <div class="custom-search-input-2">
                  <SearchForm :set-location="searchPlace" />
                </div>
              </div>
              <div class="col-xl-5 col-lg-6 text-right d-none d-lg-block illustration-left-margin">
                <img
                  src="../assets/img/illustrations/Travelers-home.png"
                  alt="Viajeros WeKeep"
                  title="Viajeros recorriendo cargando valijas"
                  class="img-fluid"
                >
              </div>
            </div>
          </div>
          <ScrollableBenefits />
        </div>
      </section>

      <!--  SHOW: ALWAYS - HOW IT WORKS  -->
      <div id="how">
        <div class="wrapper">
          <div class="container margin_80_55">
            <div class="main_title_2">
              <span><em /></span>
              <h2>{{ $t('lang.city_home.how_works_title', {city: cityName}) }}</h2>
              <h3>{{ $t('lang.home.how_works.how_works_subtitle') }}</h3>
            </div>
            <div class="row how_works_section">
              <div class="col-lg-12">
                <HowWorksCarousel />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--  SHOW: City with data - CITY NEIGHBORHOODS -->
      <div
        v-if="showCityData"
        id="city_neighborhoods"
        class="call_section"
      >
        <div class="container margin_80_55">
          <div class="main_title_2">
            <span><em /></span>
            <h2>{{ $t('lang.city_home.neighborhoods', {city: cityName}) }}</h2>
            <h3>{{ $t('lang.city_home.neighborhoods_subtitle') }}</h3>
          </div>

          <div class="row">
            <div class="col-md-12 col-lg-8 centered">
              <div class="row">
                <ul class="main-color-list arrow-list two-columns centered">
                  <li
                    v-for="(searchPlace, index) in neighborhoods"
                    :key="index"
                  >
                    <a
                      class="link-hover"
                      @click="setSearchPlace(searchPlace)"
                    >
                      {{ $t('lang.city_home.neighborhood') }}
                      <b>{{ index }}</b>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- SHOW: Only simple city - REVIEWS -->
      <div
        v-else
        class="call_section"
      >
        <div
          class="container margin_80_55 call_section"
        >
          <div class="main_title_2">
            <span><em /></span>
            <h2>{{ $t('lang.home.reviews_title') }}</h2>
            <h3>{{ $t('lang.home.reviews_subtitle') }} 😍</h3>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <ReviewsCarousel />
            </div>
          </div>
        </div>
      </div>

      <!-- SHOW: ALWAYS - PRICING LIST -->
      <Prices />

      <!--  SHOW: ALWAYS - FAQS  -->
      <div id="faqs">
        <div class="container margin_80_55">
          <div class="main_title_2">
            <span><em /></span>
            <h2>{{ $t('lang.wekeep_chat.faq') }}</h2>
            <h3>{{ $t('lang.city_home.faqs_subtitle', {city: cityName}) }} </h3>
          </div>
          <div class="row">
            <div
              id="faq"
              class="col-12"
            >
              <div
                v-for="(icon, id) in icons"
                :id="id"
                :key="id"
                role="tablist"
                class="accordion_2"
              >
                <div class="card">
                  <div
                    class="card-header"
                    role="tab"
                  >
                    <h4 class="mb-0">
                      <a
                        :id="'title_'+id"
                        class="collapsed"
                        data-toggle="collapse"
                        :href="'#collapse_'+id"
                        aria-expanded="true"
                      >
                        <i :class="'ti-'+icons[id]+' mr-3'" />
                        <i class="indicator ti-plus" />{{ questionWithCityName(id) }}
                      </a>
                    </h4>
                  </div>
                  <div
                    :id="'collapse_'+id"
                    class="collapse"
                    role="tabpanel"
                    :data-parent="'#'+id"
                  >
                    <div class="card-body">
                      <p v-html="$t('lang.help.'+id+'_text')" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <p class="w-100 text-center add_top_30">
              <a
                :href="`/${this.$store.state.main.lang}/full-help`"
                class="btn_1 rounded"
                target="_blank"
              >{{ $t('lang.city_home.see_more') }}</a>
            </p>
          </div>
        </div>
      </div>

      <!--  SHOW: City with data -CITY RESUME  -->
      <div
        v-if="showCityData"
        id="city_info"
        class="call_section"
      >
        <div
          class="container margin_80_55"
        >
          <div class="main_title_2">
            <span><em /></span>
            <h2>{{ $t('lang.city_home.waiting', {city: cityName}) }}</h2>
            <h3>{{ $t('lang.city_home.waiting_subtitle', {city: cityName}) }}</h3>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <p v-html="$t(`lang.city_home.city_intro.${city}`)" />
            </div>
          </div>
        </div>
      </div>

      <!--  SHOW: City with data -BEST PLACES CITY  -->
      <div
        v-if="showCityData"
        id="city_more_info"
      >
        <div class="container margin_80_55">
          <div class="main_title_2">
            <span><em /></span>
            <h2>{{ $t('lang.city_home.best_places_title', {city: cityName}) }}</h2>
            <h3>{{ $t('lang.city_home.best_places_subtitle') }}</h3>
          </div>
          <div class="row centered">
            <ul
              class="main-color-list centered"
              v-html="$t(`lang.city_home.city_places.${city}`)"
            />
          </div>
        </div>
      </div>

      <!-- SHOW: Only simple city - OTHER CITIES -->
      <div
        v-else
        class="call_section"
      >
        <div
          class="container margin_80_55"
        >
          <div class="main_title_2">
            <span><em /></span>
            <h2>{{ $t('lang.home.cities.title') }}</h2>
            <h3 class="mb-2">
              {{ $t('lang.home.cities.subtitle') }}
              <br>
              <span
                v-for="(country) in countriesList"
                :key="country.id"
                style="display: inline; background-color: transparent"
              >
                {{ country.icon }}
              </span>
            </h3>
          </div>
          <div class="row">
            <div class="col-lg-12 text-right mb-2">
              <b-link
                v-scroll-to="{el: '#footer_cities_list', offset: -140}"
                data-toggle="collapse"
                data-target="#collapse_ft_2"
                class="text-white"
              >
                {{ $t('lang.home.cities.see_all') }}
                <i class=" icon-right-small" />
              </b-link>
            </div>
            <div class="col-lg-12">
              <CitiesCarousel @selectedCity="setSearchCityPlace" />
            </div>
          </div>
        </div>
      </div>
    </main>
    <FooterComponent />
  </div>
</template>

<script>
import HowWorksCarousel from '@/components/Home/HowWorksCarousel';
import ReviewsCarousel from '@/components/Home/ReviewsCarousel';
import CitiesCarousel from '@/components/Home/CitiesCarousel';
import countries from '@/data/countries';
import Prices from '../components/Home/Prices';
import NavBarHome from '../components/NavBar/NavBarHome';
import SearchForm from '../components/Search/SearchForm';
import FooterComponent from '../components/FooterComponent';
import citiesNeighborhoods from '../data/citiesNeighborhoods';
import { cities } from '../data/cities';
import ScrollableBenefits from '@/components/Home/ScrollableBenefits.vue';

export default {
  name: 'CityHome',
  components: {
    ScrollableBenefits,
    CitiesCarousel,
    ReviewsCarousel,
    HowWorksCarousel,
    SearchForm,
    NavBarHome,
    FooterComponent,
    Prices,
  },

  data() {
    return {
      neighborhoods: {},
      searchPlace: {},
      city: this.$route.params.city_id,
      showCityData: false,
      countriesList: countries,
      searchParams: {},
      icons: {
        how: 'help',
        security: 'lock',
        search: 'location-pin',
        booking: 'agenda',
        after_booking: 'check-box',
        bags: 'bag',
        other: 'info',
      },
    };
  },
  computed: {
    cityName() {
      return this.$t(`lang.cities.${this.city}`);
    },
  },
  created() {
    const cityData = cities.find((data) => data.id === this.city);
    this.searchPlace = { geometry: cityData.geometry, formatted_address: this.$t(`lang.cities.${cityData.id}`) };
  },

  mounted() {
    if (this.$te(`lang.city_home.city_intro.${this.city}`)) {
      this.showCityData = true;
      this.neighborhoods = citiesNeighborhoods[this.city];
    }

    if (this.$store.state.search.searchParams != null) {
      this.searchParams = this.$store.state.search.searchParams;
    }
    const cityData = cities.find((data) => data.id === this.city);
    this.setSearchPlace({ geometry: cityData.geometry, formatted_address: this.$t(`lang.cities.${cityData.id}`) });

    //  CURRENCY BY COUNTRY
    if (this.$currencyByCountry[cityData.country]) {
      this.$store.dispatch('setCurrency', this.$currencyByCountry[cityData.country]);
    } else {
      this.$store.dispatch('setCurrency', 'USD');
    }
  },

  methods: {
    setSearchPlace(place) {
      this.searchPlace = place;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    setSearchCityPlace(city) {
      const cityData = cities.find((data) => data.id === city);
      const place = { geometry: cityData.geometry, formatted_address: this.$t(`lang.cities.${cityData.id}`) };
      this.searchPlace = place;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    openFaq(id) {
      document.getElementById(`collapse_${id}`).className += ' show';
      document.getElementById(`title_${id}`).className = 'collapse';
    },

    questionWithCityName(id) {
      const name = this.$t(`lang.help.faq.${id}`);
      return name.replace(/\?$/, this.$t('lang.city_home.faqs_city', { city: this.cityName }));
    },
  },

};
</script>
